/**
 * Usually, we support only widely available browsers based on Baseline:
 * https://web-platform-dx.github.io/web-features/supported-browsers/
 *
 * But there are some errors in Mobile Chrome 108 and iOS Safari 15.8.3. They
 * are not supported by Baseline, but we need to support them because they are
 * used by some of our users. So we need to add this polyfill for Array.prototype.toSorted
 * method.
 *
 * We can remove this polyfill when the usage of Chrome 108 and iOS Safari
 * 15.8.3 is very low.
 */
if (!Array.prototype.toSorted) {
  Object.defineProperty(Array.prototype, "toSorted", {
    value: function <T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
      return [...this].sort(compareFn);
    },
    configurable: true,
    writable: true,
    enumerable: false,
  });
}
